"use strict";
var _a, _b, _c, _d, _e;
Object.defineProperty(exports, "__esModule", { value: true });
exports.LeitungPropertiesCompact = void 0;
const echain_shared_igus_fundamentals_1 = require("@igus/echain-shared-igus-fundamentals");
/**
 * Leitung properties that are used by the individual applications detail requests.
 */
class LeitungPropertiesCompact {
}
exports.LeitungPropertiesCompact = LeitungPropertiesCompact;
_a = echain_shared_igus_fundamentals_1.AppName.TEST, _b = echain_shared_igus_fundamentals_1.AppName.EIQ, _c = echain_shared_igus_fundamentals_1.AppName.EKE, _d = echain_shared_igus_fundamentals_1.AppName.EIC, _e = echain_shared_igus_fundamentals_1.AppName.ECF;
LeitungPropertiesCompact[_a] = [];
LeitungPropertiesCompact[_b] = [
    'Id',
    'EchainId',
    'ArtNr',
    'ArticleSpecs',
    'Aussendurchmesser',
    'Bezeichnung',
    'BiegeradiusMin',
    'DiscontinuedModel',
];
LeitungPropertiesCompact[_c] = [
    'Id',
    'EchainId',
    'Aderzahl',
    'AderzahlBerechnet',
    'ArtNr',
    'ArticleSpecs',
    'AuhiFreitragendA',
    'AuhiFreitragendV',
    'AuhiGleitend',
    'AuhiGleitendA',
    'AuhiGleitendV',
    'AuhiTemperaturMax',
    'AuhiTemperaturMin',
    'Aussendurchmesser',
    'BeschleunigungHaengendMax',
    'Bezeichnung',
    'BiegeradiusMin',
    'BusSystem',
    'Categories',
    'DESINA',
    'DNV_GL',
    'DiscontinuedModel',
    'EAC',
    'FesteLaenge',
    'Flammwidrig',
    'Gesamtschirm',
    'GeschwindigkeitHaengendMax',
    'GewichtKgProKm',
    'HaengenderBetriebErlaubt',
    'Halogenfrei',
    'Kuehlmittelbestaendig',
    'Kupferzahl',
    'Leitungsaufbau',
    'MUDBestaendig',
    'MainCategory',
    'Mantelwerkstoff',
    'Manufacturer',
    'ManufacturerPartNo',
    'Oelbestaendigkeit',
    'Querschnitt',
    'RAL_Nummer',
    'Reinraum',
    'SubCategory',
    'Torsionswinkel',
    'TwistedPair',
    'UL_CSA',
    'UVBestaendigkeit',
    'VerfahrwegFreitragendMax',
    'VerfahrwegGleitendMax',
    'VerfahrwegHaengendMax',
];
LeitungPropertiesCompact[_d] = [
    'Id',
    'EchainId',
    'ArtNr',
    'ArticleSpecs',
    'Aussendurchmesser',
    'Bezeichnung',
    'BiegeradiusMin',
    'Categories',
    'FesteLaenge',
    'GewichtKgProKm',
    'Leitungsaufbau',
    'MainCategory',
    'Manufacturer',
    'ManufacturerPartNo',
    'RAL_Nummer',
    'SubCategory',
];
LeitungPropertiesCompact[_e] = LeitungPropertiesCompact[echain_shared_igus_fundamentals_1.AppName.EKE];
//# sourceMappingURL=LeitungPropertiesCompact.js.map